import React, { useState, useContext } from "react";
import AuthContext from "../../context/AuthContext";
import { updateUserData } from "../../api/users";
import MemberCard from "./MemberCard";
import "../CSS/aboutus.css";
import mem1 from "../assets/mem1.webp";
import mem4 from "../assets/mem4.webp";
import mem2 from "../assets/mem2.webp";
import mem3 from "../assets/mem3.webp";
import mem5 from "../assets/mem5.webp";
import mem6 from "../assets/mem6.webp";
import mem7 from "../assets/mem7.webp";
import mem0 from "../assets/mem0.webp";
import mem1Ios from "../assets/mem1.jpeg";
import mem4Ios from "../assets/mem4.jpeg";
import mem2Ios from "../assets/mem2.jpeg";
import mem3Ios from "../assets/mem3.jpg";
import mem5Ios from "../assets/mem5.jpeg";
import mem6Ios from "../assets/mem6.jpg";
import mem7Ios from "../assets/mem7.jpg";
import mem0Ios from "../assets/mem0.jpg";


export default function AboutUs() {
  const { user }: any = useContext(AuthContext);
  const [clicked, setClicked] = useState(false);
  const clickHandler = () => {
    setClicked(!clicked);
    if (user) {
      user.details.stats.timesGokuClicked++;
      updateUserData(user.details, user.uid, user.userType);
    }
  }

  const projectMembers1 = [
    {
      name: "Taimoor Arif",
      title: "Project Lead",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem2Ios : mem2,
      github: "https://github.com/taimoorrf",
      linkedin: "https://www.linkedin.com/in/taimoor-arif-ab23aa1b3/"
    },
    {
      name: "Nouman Abbasi",
      title: "Technical Lead",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem3Ios : mem3,
      github: "https://github.com/MNoumanAbbasi",
      linkedin: "https://www.linkedin.com/in/mnoumanabbasi/"
    },
    {
      name: "M. Hassan Mahad",
      title: "Lead Developer",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem7Ios : mem7,
      clickHandler,
      github: "https://github.com/StrawHat-14",
    },
    {
      name: "Ayaz Ur Rehman",
      title: "Developer",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem4Ios : mem4,
      github: "https://github.com/Gold7441",
      linkedin: "https://www.linkedin.com/in/ayaz-ur-rehman-306ab9143/"
    },
  ]

  const projectMembers2 = [
    {
      name: "Punnal Ismail Khan",
      title: "Developer",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem1Ios : mem1,
      github: "https://github.com/punnal",
      linkedin: "https://www.linkedin.com/in/punnal-ismail-khan-55158416a/"
    },
    {
      name: "Zoraiz Qureshi",
      title: "Developer",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem6Ios : mem6,
      github: "https://github.com/ZoraizQ",
      linkedin: "https://www.linkedin.com/in/zoraiz-qureshi-877524139/"
    },
    {
      name: "M. Bilal Naeem",
      title: "Developer",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem5Ios : mem5,
      github: "https://github.com/Martian1998",
      linkedin: "https://www.linkedin.com/in/muhammad-bilal-naeem-50b406175/"
    },
  ]

  const projectAdvisors = [
    {
      name: "Dr. Suleman Shahid",
      title: "Project Advisor",
      image: navigator.appVersion.indexOf("Mac") != -1 ? mem0Ios : mem0,
      website: "https://lums.edu.pk/lums_employee/4407",
      linkedin: "https://www.linkedin.com/in/sulemanshahid/?originalSubdomain=pk",
      advisor: true,
      description: "Assistant Professor in HCI/UX Design at LUMS, Director LUMS Learning Institute, Director Usability Lab & Facebook Innovation Lab"
    },
  ]


  return (
    <div>
      <div className="back">
        <div className="container py-5">
          <div className="row text-center text-white">
            <div className="col-lg-8 mx-auto">
              <h1 className="display-4">
                <i className="fas fa-users"></i> Team Madadgaar{" "}
              </h1>
              <p className="lead mb-0">
                We are all very different. We were born in different cities, at
                different times, we love different{" "}
                <i className="fas fa-music"></i> music,{" "}
                <i className="fas fa-utensils"></i> food,{" "}
                <i className="fas fa-gamepad"></i> video games,{" "} 
                and <i className="fas fa-ticket-alt"></i> movies. But we have
                something that unites us all. It is this platform. We are its
                heart. We are not just a team, we are a family.
              </p>
            </div>
          </div>
        </div>

        
        <div className="container">
          <div className="row text-center">
            {
              projectMembers1.map((member, index) => <MemberCard key={index} member={member}/>)
            }
          </div>
        </div>

        <div className="container">
          <div className="row text-center justify-content-center">
            {
              projectMembers2.map((member, index) => <MemberCard key={index} member={member}/>)
            }
          </div>
        </div>

        <div className="container">
          <div className="row text-center justify-content-center">
              {
                projectAdvisors.map((member, index) => <MemberCard key={index} member={member}/>)
              }
          </div>
        </div>

        <div
          className="bg-white rounded shadow-sm py-5 px-4"
          style={{ textAlign: "center" }}
        >
          <h4>
            For general queries, send us an email at:
            <br />
            <a href="mailto:madadgaarapp@gmail.com?subject=Query for Team Madadgaar">
              madadgaarapp@gmail.com
            </a>
          </h4>
        </div>
      </div>
    </div>
  );
}
